import axios from 'axios';

export async function getDuckDBStatus() {
    return await axios.get("/api/duckdb-test/status");
}

export async function getDuckDBRefreshHistory(limit = 20) {
    return await axios.get("/api/duckdb-test/refresh-history", {
        params: { limit }
    });
}

export async function triggerDuckDBRefresh(token) {
    return await axios.post("/api/duckdb-test/refresh", {}, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}
